//系统路由
import {RouteRecordRaw} from "vue-router";

const routes: RouteRecordRaw[] = [
	{
		path: "/login",
		component: () => import('@/views/system/login'),
		meta: {
			title: "登录"
		}
	},
	{
		path: "/:pathMatch(.*)*",
		name: "notFound",
		component: () => import('@/layout/404'),
		meta: {
			hidden: true
		}
	},
	{
		name: "layout",
		path: "/",
		component: () => import('@/layout'),
		redirect: '/dashboard',
		children: []
	}
]
export default routes;
